import { makeStyles } from '@material-ui/core/styles';
import { MediaQuery } from 'static/styles/jss/abstracts/mixins';
import variables from 'static/styles/jss/abstracts/variables';

export default makeStyles({
  'silver-ad--block': {
    padding: '70px 0',
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '55% 1fr',
    ...MediaQuery.down({
      padding: '50px 0',
      gridTemplateColumns: '1fr',
    }).md,
  },
  'info--block': {
    '& button': {
      margin: ({ deviceType }) =>
        deviceType === 'desktop'
          ? '32px 0 0 !important'
          : '32px auto 0 !important',
    },
    padding: '20px 0px 20px 60px',
    ...MediaQuery.down({
      padding: '8px',
    }).sm,
    ...MediaQuery.between({
      padding: '20px 0px 20px 30px',
    }).sm_md,
    '& .title-content': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '24px',
      marginBottom: '10px',
      '& span': {
        marginLeft: '10px',
      },
    },
    '& .sub-title-content': {
      color: '#C3CBD5',
      fontStyle: 'italic',
      fontSize: '18px',
    },
    '& ul': {
      paddingLeft: '15px',
      color: variables.$helperTextColor,
    },
    '& p': {
      fontSize: '15px',
      color: variables.$helperTextColor,
    },
  },
  'img--block': {
    borderRadius: '3px',
    backgroundColor: '#123982',
    boxShadow: '0 3px 6px 0 rgba(0,0,0,0.2)',
    height: '260px',
    textAlign: 'center',
    ...MediaQuery.down({
      margin: '16px 0',
    }).md,
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
});
